/**
 * Pitch Deck Version Registry
 * ────────────────────────────
 * Add new content versions here. The InvestorPitchPage reads from this registry
 * and lets you switch between versions via the UI.
 *
 * To add a new version:
 *   1. Create a new file: pitchDeckContent_v3_yourLabel.js
 *   2. Add an entry below with a unique key
 *   3. That's it — it'll appear in the version switcher
 */
import v1 from "./pitchDeckContent_v1_original";
import v2 from "./pitchDeckContent_v2_direct";
import v3 from "./pitchDeckContent_v3_emerson";

const versions = {
  v1: {
    key: "v1",
    label: "v1 — Original",
    description: "Initial pitch deck content (from PDF)",
    data: v1,
  },
  v2: {
    key: "v2",
    label: "v2 — Direct & grounded",
    description: "Removed buzzwords, hype, marketing-speak. Plain language, specific claims.",
    data: v2,
  },
  v3: {
    key: "v3",
    label: "v3 — Emerson",
    description: "Emerson-style pitch deck content.",
    data: v3,
  },
};

export const DEFAULT_VERSION = "v2";

export default versions;
